import { ThemeProvider, createGlobalStyle } from 'styled-components';
import { switchTheme } from '@insync-students-themes/utilities/utils';
import { useThemes } from '@insync-students-lib/hooks/useThemes';
import { typography } from '@insync-students-themes/abstract/theme.typography';

export const GlobalStyles = createGlobalStyle`
  :root {
    font-size: ${typography.rootFontSize};
  }
  body {
    margin: 0;
    font-family: ${typography.fonts.primary};
  }
  h1,h2,h3,h4 {
    margin:0;
  }
`;

export const AppThemeProvider = ({ children }) => {
  const [{ theme }] = useThemes();

  return (
    <ThemeProvider theme={theme ? switchTheme(theme.selected.id) : {}}>
      <GlobalStyles />
      {children}
    </ThemeProvider>
  );
};
